
var Vue = require('vue');
var $ = require('js/sw-jquery/sw-jquery');

module.exports = function ($fragment) {
  $fragment.swFindWithSelf("[data-sw-user-management]").each(function () {
    var roles = sw.data.roles;
    var optionsData = {};
    $("[data-sw-role-cateogories] option").each(function(){
      optionsData[$(this).val()] = [];
    });

    for (var i=0; i < roles.length; i++) {
      var RoleData = roles[i];
      optionsData[RoleData['role_category_id']].push({text:RoleData['role_name'] , value: RoleData['role_id']});
    }

    new Vue({
      el: this,
      data: {
        departments: '',
        optionsData: optionsData,
        selected: []
      },
      computed: {
        options: function () {
          var selectedCategory = this.departments;
          options = this.optionsData[selectedCategory];
          return options
        },
        roleIds: function () {
          return this.selected.toString()
        }
      }
    });
  });
};
